import { gql } from '@grandvisionhq/graphql';
import StoreByCodeFragment from '../fragments/store-by-code.js';

const GET_STORE_BY_CODE = gql`
  query GetStoreByCode($code: Int!) {
    store(code: $code) {
      ...StoreByCode
    }
  }
  ${StoreByCodeFragment}
`;

export { GET_STORE_BY_CODE };
//# sourceMappingURL=get-store-by-code.js.map
